document.addEventListener("DOMContentLoaded", function () {
  function handleResize() {
    if (window.innerWidth <= 750) {
      
      new Swiper(".banner-logo-swiper", {
        loop: false,
        slidesPerView: "auto",
        spaceBetween: 40,
      });
    }
  }

  handleResize();
  window.addEventListener("resize", handleResize);
});


document.querySelectorAll('.review-video-slider').forEach(function (element) {
  new Swiper(element, {
      slidesPerView: "auto",
      spaceBetween: 0,
      centeredSlides: false,
      loop: false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        749: {
          slidesPerView: "auto",
          spaceBetween: 40,
          centeredSlides: false,
          loop: false,
        }
      }
    });
});

document.querySelectorAll('.swiper-thumb-slider').forEach(function (element) {
  new Swiper(element, {
      slidesPerView: "auto",
      spaceBetween: 0,
      centeredSlides: false,
      loop: false,
      navigation: {
        nextEl: '.swiper-thumb-slider .swiper-button-next',
        prevEl: '.swiper-thumb-slider .swiper-button-prev',
      },
    });
});

if(document.querySelectorAll('.product_include_accordion_slider').length > 0) {  
  document.querySelectorAll('.product_include_accordion_slider').forEach(function (element) {
    new Swiper(element, {
        slidesPerView: "auto",
        spaceBetween: 25,
        centeredSlides: true,
        loop: false,
        navigation: {
          nextEl: '.product_include_accordion_slider .swiper-button-next',
          prevEl: '.product_include_accordion_slider .swiper-button-prev',
        },
      });
  });
};

document.addEventListener('DOMContentLoaded',()=>{
  const AllVideoTags = document.querySelectorAll('.video-popup__container');
  if(AllVideoTags.length > 0){
    AllVideoTags.forEach(video=>{
      if(video){
        const videoTag = video.querySelector('video') ;
        const playIcon = video.querySelector('.video-popup__play');
        video.addEventListener('click',()=>{
          if(videoTag.paused){            
            videoTag.play();
            playIcon.style.display = "none";
          } else{
            videoTag.pause();
            playIcon.style.display = "flex";            
          }
        })
      }
    })
  }
});

// const All_ReadMoreButtons = document.querySelectorAll('.read_more_button');
// if(All_ReadMoreButtons.length > 0){
//   All_ReadMoreButtons.forEach(button=>{
//     if(button){
//       button.addEventListener('click',()=>{
//         const closestInput = button.closest('.product_custom_desc').querySelector('.ReadMore_Text').getAttribute('value');
//         button.classList.toggle('btn-expanded');
//         if(button.classList.contains('btn-expanded')){
//           button.closest('.product_custom_desc').querySelector('.short_desc').style.display = "none";
//           button.closest('.product_custom_desc').querySelector('.main_custom_desc').style.display = "";
//           button.innerText = 'Read Less...';
//         } else{
//           // console.log(closestInput)
//           button.closest('.product_custom_desc').querySelector('.short_desc').style.display = "";
//           button.closest('.product_custom_desc').querySelector('.main_custom_desc').style.display = "none";
//           button.innerText = closestInput;
//         }
//       })
//     }
//   })
// };


  
// document.addEventListener("DOMContentLoaded", function() {

//   var firstChild = document.querySelector('.benefits-main-wrapper').firstElementChild;
//   firstChild.classList.add('current-stk');
//   firstChild.classList.add('active');
//   window.addEventListener('scroll', function() {
//     var ideasWrapperOffset = document.querySelector('.benefits-main-wrapper').getBoundingClientRect().top + window.scrollY;
//     var windowHeight = window.innerHeight;
//     var scrollPosition = window.scrollY;

//     if (scrollPosition + windowHeight >= ideasWrapperOffset) {
//       var stikyItems = document.querySelectorAll('.benefits-main-row');
//       var activeItem = null;

//       stikyItems.forEach(function(item) {
//         var itemOffset = item.getBoundingClientRect().top + window.scrollY;
//         if (scrollPosition >= itemOffset - 110) {
//           activeItem = item;
//           item.classList.add('active');
//           Array.from(item.parentNode.children).forEach(function(sibling) {
//             if (sibling !== item) {
//               sibling.classList.remove('active');
//               sibling.classList.remove('current-stk');
//             } else {
//               sibling.classList.add('current-stk');
//             }
//           });
//         }
//       });
//     }



//     const sections = document.querySelectorAll('.benefits-main-row');

//     sections.forEach(section => {
//         const sectionTop = section.getBoundingClientRect().top;
//         let opacity;

//         if (sectionTop < 0) {
//             opacity = 1 - Math.abs(sectionTop) / (windowHeight / 2);
//         } else {
//             opacity = 1 - (sectionTop / windowHeight);
//         }

//         opacity = Math.min(Math.max(opacity, 0), 1);
//         section.style.opacity = opacity;
//     });


    
//   });
// });

